import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Avatar, IconButton } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import NotFound from "../../components/not-found/NotFound";
import Pagination from "react-js-pagination";
import BabyChangingStationIcon from "@mui/icons-material/BabyChangingStation";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { notification } from "../../routes/route";
import common from "../../routes/common";
// import AddCategory from './AddCategory'
import { fatchCategoryApi } from "../../services/categoryManagement";
import { toastMessage } from "../../utils/toastMessage";
import findSerialNumber from "../../utils/findSerialNumber";
import { charLimit } from "../../utils/charLimit";
import { fetchGiftApi } from "../../services/giftManagement";
import EditIcon from "@mui/icons-material/Edit";
// import GiftStatus from "./GiftStatus";
// import AddGift from "./AddGift";
// import EditGift from "./EditGift";
import AddIcon from "@mui/icons-material/Add";
import DescriptionModel from "../../components/imagePreview/DescriptionModel";
import AddNotification from "./AddNotification";
import ScheduledNotification from "./ScheduledNotification";
import { deleteNotificationApi, notificationListingApi, getNotificationDetailsApi } from "../../services/notificationManagement";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import { dateFormatWithTime } from "../../utils/dateFormat";
import DeleteIcon from "@mui/icons-material/Delete";
import ModalBox from "../../components/modal/ModalBox";
import useButtonLoader from "../../hooks/UseButtonLoader";
import axios from "axios";
import { Add_Message, Update_message } from "../../services/cms";
import NotificationManagementIndex from ".";
import EnhancedNotificationManagement from "./EnhancedNotificationManagement";
import AutomaticNotification from "./AutomaticNotification";
import FollowupManagement from "./FollowupManagement";
import VedicMeetAutomaticNotification from "./VedicMeetAutomaticNotification";
// import CategoryStatus from './CategoryStatus'
const { ADD_NOTIFICATION } = notification;
const { NOT_FOUND } = common;

const Notification = () => {
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  const [search, setSearch] = useState(
    getLocalStorage("notificationList", "search") || ""
  );
  const [activeTab, setActiveTab] = useState("notification"); // Add tab state
  const problems = [
    "depression",
    "career",
    "marriage",
    "relationship",
    "finance",
    "exam",
    "health",
    "family"
  ];
  const debounceValue = useDebounce(search || "", 300);
  const [buttonRef, buttonLoader] = useButtonLoader("Yes");
  const [addNotificationModal, setAddNotificationModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [notificationList, setNotificationList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [selectedNotification, setSelectedNotification] = useState({});
  const [description, setDescription] = useState({});
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [commonmessageModal, setCommonmessageModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [notificationDetails, setNotificationDetails] = useState(null);
  const [detailsLoader, setDetailsLoader] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [notes, setNotes] = useState(Array(problems.length).fill(""));
  const [error, setError] = useState("");
  const [isNewMessage, setIsNewMessage] = useState(false);


  useEffect(() => {
    setLocalStorage("notificationList", "search", search);
  }, [search]);

  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  //   ********Edit data*************//
  const editHandler = (data) => {
    setSelectedNotification(data);
    setEditModal(true);
  };

  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  // close model
  const closeModel = () => {
    setStatusValue("");
    setStatusId("");
    setStatusModal(false);
  };

  // //------------------listing-Category-Api----------------------------------
  const fetchNotificationHandler = async (debounceValue) => {
    try {
      const sendData = {};
      setNotificationList([]);
      showLoader();
      sendData.limit = "10";
      sendData.page = activePage;
      if (debounceValue) {
        sendData.page = "1";
        sendData.search = debounceValue;
        searchParam.delete("page");
        setSearchParam(searchParam);
      }
      setSearchParam(searchParam);
      const res = await notificationListingApi(sendData);
      if (res.data.code === 200) {
        setNotificationList(res?.data?.result?.list || []);
        setTotal(res?.data?.result?.total || 0);
      } else {
        setNotificationList([]);
        setTotal(0);
        toastMessage(res.data.message, "error", "notificationList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // Delete Notification Handler
  const deleteNotificationHandler = async () => {
    try {
      buttonLoader(true);
      const res = await deleteNotificationApi({
        notificationId: statusId,

      });
      if (res?.data?.code === 200) {
        toastMessage(res?.data?.message, "success", "deleteNotification");
        setDeleteModal(false);
        fetchNotificationHandler();
      } else {
        toastMessage(res?.data?.message, "error", "deleteNotification");
      }
    } catch (e) {
      console.log(e.message);
    } finally {
      buttonLoader(false);
    }
  };

  const onClose = () => {
    setDescription(null);
    setDescriptionModal(false);
  };

  // Fetch notification details handler
  const fetchNotificationDetails = async (notificationId) => {
    try {
      setDetailsLoader(true);
      setViewModal(true);
      const res = await getNotificationDetailsApi({ notificationId });
      if (res?.data?.code === 200) {
        setNotificationDetails(res?.data?.result);
      } else {
        toastMessage(res?.data?.message || "Failed to fetch notification details", "error", "notificationDetails");
        setViewModal(false);
      }
    } catch (error) {
      console.log("error fetching notification details", error);
      toastMessage("Failed to fetch notification details", "error", "notificationDetails");
      setViewModal(false);
    } finally {
      setDetailsLoader(false);
    }
  };

  const closeViewModal = () => {
    setViewModal(false);
    setNotificationDetails(null);
  };

  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    fetchNotificationHandler(debounceValue);
  }, [searchParam, debounceValue]);

  useEffect(() => {
    fetchNotificationHandler();
  }, []);

  useEffect(() => {
    if (commonmessageModal && !isNewMessage) {
      fetchPreviousMessages();
    }
  }, [commonmessageModal, isNewMessage]);


  const handleClick = () => {
    setIsClicked(true);
    setTimeout(() => setIsClicked(false), 150);

    handlesubmit();
  };

  const handleNoteChange = (index, value) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = value;
    setNotes(updatedNotes);
  };




  const handlesubmit = async () => {

    const hasEmptyNote = notes.some(note => !note || note.trim() === "");

    if (hasEmptyNote) {
      setError("Please fill all notes before submitting.");
      return;
    }

    setError("");
    const dataToSend = problems.map((problem, index) => ({
      problem: problem.toLowerCase(),
      message: notes[index]?.trim() || "",
    }));

    console.log("datasend to backend -->", dataToSend)
    try {

      const { data: respone } = await Add_Message(dataToSend)
      if (respone.success) {
        toastMessage(respone.message || "Message updated successfully", "success", "addNotification")
        setCommonmessageModal(false);
        // fetchNotificationHandler();
      } else {
        toastMessage(respone.message || "Failed to send message", "error", "addNotification")
      }
      console.log('response-->formcommon', respone)
      // setNotes(Array(problems.length).fill(""));
    } catch (error) {
      console.log(error.message)
    }
  }


  useEffect(() => {
    if (commonmessageModal) {
      fetchPreviousMessages();
    }
  }, [commonmessageModal]);

  const fetchPreviousMessages = async () => {
    try {
      const { data } = await Update_message();
      if (data.success && data.data) {
        const messages = data.data.messages;
        const filledNotes = problems.map(problem => {
          const found = messages.find(msg => msg.problem === problem);
          return found ? found.message : "";
        });
        setNotes(filledNotes);
      } else {
        setNotes(Array(problems.length).fill(""));
      }
    } catch (error) {
      console.error("Failed to fetch previous messages", error);
      setNotes(Array(problems.length).fill(""));
    }
  };


  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Notification Management</h4>

          </div>

          {/* Tab Navigation */}
          <div className="tab-navigation" style={{ marginBottom: '20px' }}>
            <div className="tab-buttons block_user_button " style={{ display: 'flex', flexWrap: 'wrap', borderBottom: '2px solid #e0e0e0' }}>
              <button
                onClick={() => setActiveTab("notification")}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === "notification" ? '#ff8989' : 'transparent',
                  color: activeTab === "notification" ? 'white' : '#666',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === "notification" ? 'bold' : 'normal',
                  borderBottom: activeTab === "notification" ? '3px solid #ff8989' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Notifications
              </button>
              <button
                onClick={() => setActiveTab("scheduled")}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === "scheduled" ? '#ff8989' : 'transparent',
                  color: activeTab === "scheduled" ? 'white' : '#666',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === "scheduled" ? 'bold' : 'normal',
                  borderBottom: activeTab === "scheduled" ? '3px solid #ff8989' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Scheduled Notifications
              </button>
              <button
                onClick={() => setActiveTab("analytics")}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === "analytics" ? '#ff8989' : 'transparent',
                  color: activeTab === "analytics" ? 'white' : '#666',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === "analytics" ? 'bold' : 'normal',
                  borderBottom: activeTab === "analytics" ? '3px solid #ff8989' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Daily Notifications
              </button>
              <button
                onClick={() => setActiveTab("automatic")}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === "automatic" ? '#ff8989' : 'transparent',
                  color: activeTab === "automatic" ? 'white' : '#666',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === "automatic" ? 'bold' : 'normal',
                  borderBottom: activeTab === "automatic" ? '3px solid #ff8989' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Automatic Notifications
              </button>
              <button
                onClick={() => setActiveTab("vedicmeetAutomatic")}
                style={{
                  padding: '12px 24px', border: 'none',
                  background: activeTab === "vedicmeetAutomatic" ? '#ff8989' : 'transparent',
                  color: activeTab === "vedicmeetAutomatic" ? 'white' : '#666', cursor: 'pointer', fontSize: '16px',
                  fontWeight: activeTab === "vedicmeetAutomatic" ? 'bold' : 'normal',
                  borderBottom: activeTab === "vedicmeetAutomatic" ? '3px solid #ff8989' : 'none', transition: 'all 0.3s ease'
                }}
              >
                VedicMeet Automatic Notification
              </button>
              <button
                onClick={() => setActiveTab("followup")}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: activeTab === "followup" ? '#ff8989' : 'transparent',
                  color: activeTab === "followup" ? 'white' : '#666',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === "followup" ? 'bold' : 'normal',
                  borderBottom: activeTab === "followup" ? '3px solid #ff8989' : 'none',
                  transition: 'all 0.3s ease'
                }}
              >
                Follow-up Management
              </button>

            </div>
          </div>

          {/* Tab Content */}
          {activeTab === "notification" && (
            <>
              <div className="content-table">
                <div className="block_user_button mb-2">
                  <button onClick={() => setAddNotificationModal(true)}>
                    <AddIcon />
                    Add Notification
                  </button>
                  <button onClick={() => setCommonmessageModal(true)}>
                    <AddIcon />
                    Send Common-Message
                  </button>
                  {/* <Link to={`${ADD_NOTIFICATION}`}>
                <div className="block_user_button">
                  <button>
                    <AddIcon />
                    Add Notification
                  </button>
                </div>
              </Link> */}
                </div>
                <table>
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Created At</th>
                      {/* <th>Title</th> */}
                      <th>Message</th>
                      <th>User Type</th>
                      <th>Source</th>
                      <th className="text-center"> Action </th>
                    </tr>
                  </thead>

                  <tbody>
                    {notificationList.length > 0 ? (
                      notificationList.map((notification, index) => {
                        return (
                          <React.Fragment key={notification._id}>
                            <tr>
                              <td>{findSerialNumber(index, activePage, 10)}</td>
                              <td>{dateFormatWithTime(notification.createdAt)}</td>
                              {/* <td>{charLimit(notification.title, 40) || "---"}</td> */}

                              <td
                                onClick={() => {
                                  if (
                                    notification.message &&
                                    notification.message.length > 50
                                  ) {
                                    setDescriptionModal(true);
                                    setDescription({
                                      ...description,
                                      message: notification.message,
                                      title: notification?.title,
                                    });
                                  }
                                }}
                              >
                                {notification?.message &&
                                  (notification.message.length > 50
                                    ? charLimit(notification.message, 50)
                                    : notification.message || "---")}
                              </td>
                              <td>
                                {notification?.userType === "cons"
                                  ? "Consultant"
                                  : "User"}
                              </td>
                              <td>
                                {notification?.source === "claude_ops_chat" ? (
                                  <span
                                    style={{
                                      padding: "3px 8px",
                                      borderRadius: "4px",
                                      backgroundColor: "#e3f2fd",
                                      color: "#1565c0",
                                      fontSize: "12px",
                                      fontWeight: 600,
                                    }}
                                    title={
                                      notification?.sourceMeta?.sessionId
                                        ? `Claude Ops Chat · session ${notification.sourceMeta.sessionId}`
                                        : "Created via Claude Ops Chat"
                                    }
                                  >
                                    Claude Ops
                                  </span>
                                ) : (
                                  <span style={{ fontSize: "12px", color: "#666" }}>Admin</span>
                                )}
                              </td>
                              <td>
                                <div className="action_button" style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                  {notification.status=="sent"?"Sent":"Not Sent"}
                                  <IconButton
                                    aria-label="view"
                                    className="px-2 py-0"
                                    onClick={() => fetchNotificationDetails(notification._id)}
                                    title="View Details"
                                  >
                                    <VisibilityIcon className="edit_icon" style={{ color: '#1976d2' }} />
                                  </IconButton>
                                  {/* <IconButton
                                    aria-label="update"
                                    className="px-2 py-0"
                                    onClick={() => {
                                      setDeleteModal(true);
                                      setStatusId(notification._id);
                                    }}
                                  >
                                    <DeleteIcon className="edit_icon" />
                                  </IconButton> */}
                                  {/* <Switch
                                    checked={notification.status}
                                    onChange={() =>
                                      statusUpdateHandler(notification._id, notification.status)
                                    }
                                  /> */}
                                </div>
                              </td>
                            </tr>
                          </React.Fragment>
                        );
                      })
                    ) : (
                      <NotFound
                        cols={7}
                        msg="Notification not found!"
                        icon={NOT_FOUND}
                        loader={loader}
                      />
                    )}
                  </tbody>
                </table>
              </div>
              {total >= 10 ? (
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={10}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                  />
                </div>
              ) : null}
            </>
          )}
          {activeTab === "scheduled" && (
            <ScheduledNotification />
          )}
          {activeTab === "analytics" && (
            <EnhancedNotificationManagement />
          )}
          {activeTab === "automatic" && (
            <AutomaticNotification />
          )}
          {activeTab === "vedicmeetAutomatic" && (
            <VedicMeetAutomaticNotification />
          )}
          {activeTab === "followup" && (
            <FollowupManagement />
          )}

        </div>
        {addNotificationModal && (
          <AddNotification
            show={addNotificationModal}
            close={() => setAddNotificationModal(false)}
            listing={fetchNotificationHandler}
          />
        )}

        {commonmessageModal && (
          <ModalBox
            status={commonmessageModal}
            onClose={() => setCommonmessageModal(false)}
            title={"Send Common Message"}
            size={"sm"}
            closeIcon
            custom
            customizedFooter={
              <div className="p-2" style={{ width: '100%' }}>
                <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '14px' }}>
                  <thead>
                    <tr style={{ display: 'flex', alignItems: 'center' }}>
                      <th style={{ flex: '0 0 35%', fontSize: '20px' }}>Problem Name</th>
                      <th style={{ flex: '1 0 40%', fontSize: '20px', paddingLeft: '20px' }}>Write Message</th>
                      <th style={{ flex: '0 0 20%', textAlign: 'right' }}>
                        <button
                          onClick={() => {
                            setIsNewMessage(true);
                            setNotes(Array(problems.length).fill(''));
                          }}
                          style={{
                            backgroundColor: '#ff8989',
                            color: 'white',
                            border: 'none',
                            padding: '6px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontSize: '14px',
                          }}
                        >
                          Empty All
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {problems.map((problem, index) => (
                      <tr key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '7px', }}>
                        <td style={{ flex: '0 0 35%' }}>
                          <div
                            style={{
                              backgroundColor: '#f5f5f5',
                              border: '1px solid #ccc',
                              borderRadius: '10px',
                              padding: '8px',
                              textAlign: 'center',
                              fontSize: '18px',
                              color: 'black',
                            }}
                          >
                            {problem}
                          </div>
                        </td>
                        <td style={{ flex: '1 0 55%', paddingLeft: '20px' }}>
                          <textarea
                            rows="2"
                            style={{
                              width: '100%',
                              padding: '8px',
                              borderRadius: '10px',
                              border: '1px solid #ccc',
                              resize: 'vertical',
                              fontSize: '16px',
                            }}
                            value={notes[index]}
                            onChange={(e) => handleNoteChange(index, e.target.value)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>


                {error && (
                  <div style={{ color: "red", marginBottom: "10px", fontSize: "13px" }}>
                    {error}
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <button
                    onClick={handleClick}
                    style={{
                      width: '60%',
                      borderRadius: '10px',
                      backgroundColor: '#ff8989',
                      padding: '10px',
                      color: 'white',
                      fontSize: '16px',
                      border: 'none',
                      cursor: 'pointer',
                      marginTop: '5px',
                      transition: 'transform 0.15s',
                      transform: isClicked ? 'scale(0.95)' : 'scale(1)',
                    }}
                  >
                    Send Message
                  </button>
                </div>

              </div>

            }
          />
        )}
        {/* {statusModal && (
          <notificationStatus
            show={statusModal}
            close={closeModel}
            listing={notificationList}
            setListing={setNotificationList}
            status={statusValue}
            id={statusId}
          />
        )}
        {editModal && (
          <EditGift
            setEditModal={setEditModal}
            editModal={editModal}
            selectedNotification={selectedNotification}
            setSelectedNotification={setSelectedNotification}
            fetchNotificationHandler={fetchNotificationHandler}
          />
        )} */}

        <DescriptionModel
          show={descriptionModal}
          close={onClose}
          description={description?.message}
          title={description?.title}
        />

        <ModalBox
          status={deleteModal}
          onClose={() => setDeleteModal(false)}
          title={"Delete Notification"}
          description={"Are you sure want to delete this notification?"}
          action={deleteNotificationHandler}
          ref={buttonRef}
        />

        {/* View Notification Details Modal */}
        {viewModal && (
          <ModalBox
            status={viewModal}
            onClose={closeViewModal}
            title={"Notification Details"}
            size={"lg"}
            closeIcon
            custom
            customizedFooter={
              <div style={{ padding: '20px', textAlign: 'right' }}>
                <button
                  onClick={closeViewModal}
                  style={{
                    backgroundColor: '#ff8989',
                    color: 'white',
                    border: 'none',
                    padding: '10px 20px',
                    borderRadius: '6px',
                    cursor: 'pointer',
                    fontSize: '16px'
                  }}
                >
                  Close
                </button>
              </div>
            }
          >
            <div style={{ padding: '20px' }}>
              {detailsLoader ? (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p>Loading notification details...</p>
                </div>
              ) : notificationDetails ? (
                <div>
                  {/* Notification Info */}
                  <div style={{ marginBottom: '30px' }}>
                    <h3 style={{ marginBottom: '15px', color: '#333', borderBottom: '2px solid #ff8989', paddingBottom: '10px' }}>
                      Notification Information
                    </h3>
                    <div style={{ display: 'grid', gap: '15px' }}>
                      <div>
                        <strong>Title:</strong>
                        <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                          {notificationDetails.notification?.title || 'N/A'}
                        </p>
                      </div>
                      <div>
                        <strong>Message:</strong>
                        <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', whiteSpace: 'pre-wrap' }}>
                          {notificationDetails.notification?.message || 'N/A'}
                        </p>
                      </div>
                      <div>
                        <strong>Sent At:</strong>
                        <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                          {notificationDetails.notification?.sentAt
                            ? dateFormatWithTime(notificationDetails.notification.sentAt)
                            : 'N/A'}
                        </p>
                      </div>
                      <div>
                        <strong>Type:</strong>
                        <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                          {notificationDetails.notification?.type || notificationDetails.notification?.notificationType || 'N/A'}
                        </p>
                      </div>
                      <div>
                        <strong>Source:</strong>
                        <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px' }}>
                          {notificationDetails.notification?.source === 'claude_ops_chat'
                            ? 'Claude Ops Chat'
                            : (notificationDetails.notification?.source || 'Admin panel')}
                          {notificationDetails.notification?.sourceMeta?.model
                            ? ` · ${notificationDetails.notification.sourceMeta.model}`
                            : ''}
                        </p>
                      </div>
                      {notificationDetails.notification?.sourceMeta?.audienceFilters ? (
                        <div>
                          <strong>Audience filters:</strong>
                          <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px', fontFamily: 'monospace', fontSize: '12px' }}>
                            {JSON.stringify(notificationDetails.notification.sourceMeta.audienceFilters)}
                          </p>
                        </div>
                      ) : null}
                      {notificationDetails.notification?.error ? (
                        <div>
                          <strong>Error:</strong>
                          <p style={{ margin: '5px 0', padding: '10px', backgroundColor: '#ffebee', borderRadius: '6px', color: '#c62828' }}>
                            {notificationDetails.notification.error}
                          </p>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  {/* User Metrics */}
                  {notificationDetails.userMetrics && (
                    <div>
                      <h3 style={{ marginBottom: '15px', color: '#333', borderBottom: '2px solid #ff8989', paddingBottom: '10px' }}>
                        User Metrics
                      </h3>
                      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' }}>
                        <div style={{ padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', textAlign: 'center' }}>
                          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#1976d2' }}>
                            {notificationDetails.userMetrics.totalUsersNotified || 0}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                            Total Users Notified
                          </div>
                        </div>
                        <div style={{ padding: '15px', backgroundColor: '#e3f2fd', borderRadius: '8px', textAlign: 'center' }}>
                          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#2e7d32' }}>
                            {notificationDetails.userMetrics.totalUsersReceived || 0}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                            Total Users Received
                          </div>
                        </div>
                        <div style={{ padding: '15px', backgroundColor: '#e8f5e9', borderRadius: '8px', textAlign: 'center' }}>
                          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#2e7d32' }}>
                            {notificationDetails.userMetrics.usersWithPurchases || 0}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                            Users With Purchases
                          </div>
                        </div>

                        <div style={{ padding: '15px', backgroundColor: '#fff3e0', borderRadius: '8px', textAlign: 'center' }}>
                          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#f57c00' }}>
                            {notificationDetails.userMetrics.usersWithoutPurchases || 0}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                            Users Without Purchases
                          </div>
                        </div>
                        <div style={{ padding: '15px', backgroundColor: '#f3e5f5', borderRadius: '8px', textAlign: 'center' }}>
                          <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#7b1fa2' }}>
                            {notificationDetails.userMetrics.notificationToPurchaseRatio || '0:0'}
                          </div>
                          <div style={{ fontSize: '14px', color: '#666', marginTop: '5px' }}>
                            Purchase Ratio
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div style={{ textAlign: 'center', padding: '40px' }}>
                  <p>No details available</p>
                </div>
              )}
            </div>
          </ModalBox>
        )}
      </div>
    </>
  );
};

export default Notification;
